"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Button: () => button_default
});
module.exports = __toCommonJS(src_exports);

// src/button.tsx
var import_ui = require("@numa-group/ui.button-or-link");
var import_react = require("react");
var import_styled_components3 = __toESM(require("styled-components"));

// src/spinner.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Svg = import_styled_components.default.svg`
  vertical-align: sub;
`;
var Spinner = () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Svg, { width: "1em", height: "1em", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { fill: "none", fillRule: "evenodd", strokeWidth: "4", children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { strokeOpacity: ".5", cx: "20", cy: "20", r: "18", stroke: "currentColor" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", { transform: "translate(2 2)", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M36 18c0-9.94-8.06-18-18-18", stroke: "currentColor", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "animateTransform",
    {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    }
  ) }) })
] }) });
var spinner_default = Spinner;

// src/styles.ts
var import_styled_components2 = __toESM(require("styled-components"));
var borderVariant = import_styled_components2.css`
  box-shadow: inset 0 0 0 2px currentColor;
`;
var variantStyles = {
  primary: import_styled_components2.css`
    color: var(--color-white);
    background-color: var(--color-numa-black--400);

    &:hover {
      background-color: var(--color-numa-black--300);
    }

    &:disabled {
      background-color: var(--color-numa-black--200);
      color: var(--color-white);
    }

    &:active {
      background-color: var(--color-numa-black--400);
    }
  `,
  secondary: import_styled_components2.css`
    color: var(--color-numa-black--400);
    background-color: var(--color-white);
    ${() => borderVariant}

    &:hover {
      box-shadow: inset 0 0 0 3px currentColor;
    }

    &:active {
      color: var(--color-white);
      background-color: var(--color-numa-black--400);
      box-shadow: inset 0 0 0 3px var(--color-numa-black-400);
    }
  `,
  negative: import_styled_components2.css`
    color: var(--color-numa-red--100);
    background-color: var(--color-white);
    ${() => borderVariant}

    &:hover {
      box-shadow: inset 0 0 0 3px currentColor;
      color: var(--color-numa-red--200);
    }

    &:active {
      color: var(--color-white);
      background-color: var(--color-numa-red--100);
      box-shadow: inset 0 0 0 3px var(--color-numa-red-100);
    }

    &:disabled {
      color: var(--color-numa-red--50);
      box-shadow: inset 0 0 0 3px currentColor;
    }
  `,
  link: import_styled_components2.css`
    color: var(--color-numa-black--400);
    background-color: transparent;
    text-decoration: underline;

    &:hover {
      color: var(--color-numa-black--300);
    }

    &:disabled {
      color: var(--color-numa-black--200);
    }
  `
};
var wrapperStyles = import_styled_components2.css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0;
  padding: var(--spacing-4) var(--spacing-8);
  border: none;
  cursor: pointer;
  font: var(--font-body--medium);
  font-size: 18px;
  line-height: 21.42px;
  transition: var(--transition--default);
  transition-property: background-color, color;
  border-radius: 8px;

  @media screen and (min-width: 768px) {
    display: inline-flex;
  }

  svg {
    display: block;
  }

  &:disabled {
    color: var(--color-numa-black--250);
    pointer-events: none;
  }

  ${({ $isLoading }) => $isLoading && import_styled_components2.css`
      pointer-events: none;
    `}

  ${({ $variant }) => variantStyles[$variant]}
`;
var ButtonWrapper = import_styled_components2.default.button`
  ${wrapperStyles}
`;
var LinkButtonWrapper = import_styled_components2.default.a`
  ${wrapperStyles}
`;
var ChildContainer = import_styled_components2.default.span`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  visibility: ${({ $isVisible }) => $isVisible ? "visible" : "hidden"};
`;
var Indicator = import_styled_components2.default.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
var LoadingIndicator = (0, import_styled_components2.default)(Indicator)``;

// src/button.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Button = (0, import_react.forwardRef)((props, ref) => {
  const content = /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_jsx_runtime2.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(ChildContainer, { $isVisible: !props.isLoading, children: props.children }),
    props.isLoading && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(LoadingIndicator, { "aria-busy": "true", "aria-live": "polite", role: "status", children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(spinner_default, {}) })
  ] });
  if ((0, import_ui.isLink)(props)) {
    const _a = props, { variant: variant2 = "primary", isLoading: isLoading2 = false, children: children2, type } = _a, restProps2 = __objRest(_a, ["variant", "isLoading", "children", "type"]);
    const _b = restProps2, { isExternal } = _b, linkProps = __objRest(_b, ["isExternal"]);
    const linkButtonProps = __spreadValues(__spreadValues({}, linkProps), isExternal && {
      target: "_blank",
      rel: "noreferrer noopener"
    });
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
      LinkButtonWrapper,
      __spreadProps(__spreadValues({
        ref
      }, linkButtonProps), {
        $variant: variant2,
        $isLoading: isLoading2,
        children: content
      })
    );
  }
  const _c = props, { variant = "primary", isLoading = false, children } = _c, restProps = __objRest(_c, ["variant", "isLoading", "children"]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    ButtonWrapper,
    __spreadProps(__spreadValues({
      ref,
      $variant: variant,
      $isLoading: isLoading
    }, restProps), {
      children: content
    })
  );
});
Button.displayName = "Button";
var button_default = (0, import_styled_components3.default)(Button)``;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button
});
